import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { drawerWidth } from '../../../styleVariables';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';

import {
  getSubscriptionPlans, paySubscriptionAction, getSubscriptionStatus,
  updateFreeTrialModal,
  getPaymentLink,
  updatePaymentFailedModal
} from "../../../store/actions/paymentsActionCreator";
import { IconButton } from '@material-ui/core';
import Button from '../Actions/ActionIconButton';
import DriverDetailsDialog from "../DieselCardComponents/DriverDetailsDialog";

const useStyles = makeStyles(theme => ({
  content: {
    backgroundColor: '#f1f1f3',
    minWidth: 0,
    width: '100%',
    padding: 15,
    paddingBottom: 0,
    height: 'calc(100vh - 70px)',
    position: 'relative',
    overflow: 'auto',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '-webkit-overflow-scrolling': 'touch'
  },
  'content-left': {
    [theme.breakpoints.up('md')]: {
      marginLeft: -drawerWidth
    }
  },
  'content-right': {
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  'contentShift-left': {
    marginLeft: 0
  },
  'contentShift-right': {
    marginRight: 0
  },
  subscriptionStatusDiv: {
    width: '100%',
    height: 40,
    // margin:'0 8px',
    borderRadius: 4,
    border: "2px solid #de1c22",
    backgroundColor: " #ffe68a",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: 'center',
    padding: '0 16px',
    "& .item": {
      width: "33.333%"
    },
    "&span:nth-child(2)": {
      alignSelf: 'flex-end'
    }
  },
  subscriptionStatusBox: {
    width: '100%',
    height: 40,
    // margin:'0 8px',
    borderRadius: 4,
    border: "2px solid #de1c22",
    backgroundColor: " #ffe68a",
    padding: '0 16px'
  },
  pad: {
    padding: '0 8px',
    cursor: 'pointer',
  },
  status: {
    fontSize: 16,
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "normal",
    color: "#0b1323"
  },
  checkPrice: {
    float: 'right',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: "#de1c22",
  },
  go: {
    marginLeft: 16,
    color: "#de1c22",
  },
  divDieselCardContainer: {
    backgroundColor: '#415da6',
    height: '58px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '-15px',
    marginLeft: '-15px',
    width: '103%'
  },
  divContent: {
    display: 'flex',
    width: '97%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tryNowButton: {
    backgroundColor: 'white',
    padding: '6px 25px 6px 25px',
    borderRadius: '4px',
    boxShadow: 'none !important',
    color: '#415da6',
    fontWeight: 600,
    fontSize: 14,
    marginLeft: 24,
    "&:hover": {
      backgroundColor: 'white'
    }
  },
  divContentText: {
    fontSize: 18,
    color: 'white',
    fontWeight: 500
  },
  closeIcon: {
    fontSize: 20,
    color: 'white'
  }
}));

const Workspace = ({ user, vehicle, history, location, payments, children, opened, subscriptionStatus, dispatchGetSubscriptionPaymentLinkAction }) => {

  const [showDieselBanner, setShowDieselBanner] = useState(false);
  const [fuelCardActivation, setFuelCardActivation] = useState(false);

  const classes = useStyles();

  const singleTruckData = vehicle && vehicle.singleTruck ? vehicle.singleTruck : {}
  const checkDieselBanner = localStorage.getItem("DieselCardBannerSingleTruck");

  useEffect(() => {

    if (!checkDieselBanner) {
      setShowDieselBanner(true)
    }

  }, [checkDieselBanner])

  const fuelCardConfigInfo = user && user.fuelCardConfig ? user.fuelCardConfig : {}

  const goToPremium = (data) => {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
  }
  const goOrderView = (orderId) => {
    if (orderId) {
      history.push({
        pathname: `/payments/order_status/${orderId}`,
        state: {
          orderId: orderId,
          pageTitle: 'Premium',
        }
      });
    }
  }
  const goToTryAgainPayment = (data) => {
    if (payments && payments.paymentFailed && payments.paymentFailed === true && payments.subscriptionStatus && payments.subscriptionStatus.orderId) {
      dispatchGetSubscriptionPaymentLinkAction(
        payments.subscriptionStatus.orderId,
        (data) => {
          if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
            window.location.href = data.response.paymentLink;
          }
        },
        () => { },
      )
    }
  }

  const handleDieselBannerClose = () => {
    setShowDieselBanner(false);
    localStorage.setItem("DieselCardBannerSingleTruck", "shown")
  }

  const handleSingleDieselRedirection = () => {

    const fuelBrokerId = singleTruckData && singleTruckData.vehicleFuelCards && singleTruckData.vehicleFuelCards[0] && singleTruckData.vehicleFuelCards[0].brokerId ? singleTruckData.vehicleFuelCards[0].brokerId : ""
    if (fuelBrokerId) {
      history.push({
        pathname: `/diesel-card/single-diesel-card/${singleTruckData && singleTruckData.id ? singleTruckData.id : ""}/${fuelBrokerId ? fuelBrokerId : ""}`,
        state: {
          id: 1,
          pageTitle: "Diesel Card",
          vehicleNumber: singleTruckData && singleTruckData.vehicleNumberArrayDweb ? singleTruckData.vehicleNumberArrayDweb : []
        }
      })
    } else {
      setFuelCardActivation(true);
    }
  }

  const handleDriverDetailsClose = () => {
    setFuelCardActivation(false);
  }

  return (
    <main
      className={classNames(classes.content, classes[`content-left`], {
        [classes.contentShift]: opened,
        [classes[`contentShift-left`]]: opened
      })}
    >
      {/*location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium")) && payments && payments.subscriptionStatus
            && payments.subscriptionStatus.numberOfDays
            && payments.subscriptionStatus.numberOfDays <=7
          && payments.subscriptionStatus.orderId==null&& */}
      {/* {location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium")) && payments && payments.subscriptionStatus
            && payments.subscriptionStatus.status &&
            payments.subscriptionStatus.subscriptionType
            && payments.subscriptionStatus.status=="ACTIVE"
            && payments.subscriptionStatus.subscriptionType ==="FREE_TRIAL" &&
      <div className={classes.pad} onClick={goToPremium} >
        <div className={classes.subscriptionStatusDiv}>
          <div className="item">

          </div>
          <div className="item">
            <span className={classes.status}>Your Free trial will be ending in {payments.subscriptionStatus.numberOfDays?payments.subscriptionStatus.numberOfDays>1?payments.subscriptionStatus.numberOfDays+' Days':payments.subscriptionStatus.numberOfDays+' Day':"0 Day"}</span>
          </div>
          <div className="item">
            <span className={classes.checkPrice}>Check Pricing <ChevronRightIcon className={classes.go} /></span>
          </div>
        </div>
      </div>} */}

      {/* *********************************** Single Truck Diesel Card Banner *********************************** */}
      {/* {location && location.pathname && location.pathname.includes("/trucks/single-truck") && showDieselBanner && vehicle && vehicle.singleTruck && vehicle.singleTruck.ownershipType && vehicle.singleTruck.ownershipType != "HIRED" &&
        <div className={classes.divDieselCardContainer}>
          <div className={classes.divContent}>
            <div className={classes.divContentText}>{fuelCardConfigInfo && fuelCardConfigInfo.listing_page_text ? fuelCardConfigInfo.listing_page_text : ""}</div>
            <Button className={classes.tryNowButton} variant="contained" onClick={() => handleSingleDieselRedirection()}>Try it Now</Button>
          </div>
          <div>
            <IconButton onClick={() => handleDieselBannerClose()}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </div>
        </div>
      } */}

      {user && user.userInfo && user.userInfo.role && user.userInfo.role != "USER" && location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium")) && payments && payments.subscriptionStatus
        && (typeof payments.subscriptionStatus.numberOfDays != 'undefined' || payments.subscriptionStatus.numberOfDays != null)
        && (payments.subscriptionStatus.numberOfDays <= 10 || payments.subscriptionStatus.numberOfDays == 0)
        && payments.subscriptionStatus.orderId == null &&
        <div className={classes.pad} onClick={goToPremium} >
          <div className={classes.subscriptionStatusDiv}>
            <div className="item">

            </div>
            <div className="item">
              <span className={classes.status}>
                Your {payments && payments.subscriptionStatus
                  && payments.subscriptionStatus.status &&
                  payments.subscriptionStatus.subscriptionType
                  && payments.subscriptionStatus.status == "ACTIVE"
                  && payments.subscriptionStatus.subscriptionType === "PAID" ? "Subscription" : "Free Trial"} {!payments.subscriptionStatus.isExpired ? "will be ending" : 'Expired'} {!payments.subscriptionStatus.isExpired && <span>{payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays > 1 ? ' in ' + payments.subscriptionStatus.numberOfDays + ' Days' : ' in ' + payments.subscriptionStatus.numberOfDays + ' Day' : "Today"}</span>}
              </span>
            </div>
            <div className="item">
              <span className={classes.checkPrice}>Check Pricing <ChevronRightIcon className={classes.go} /></span>
            </div>
          </div>
        </div>}
      {location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium") || !location.state.orderId)
        && payments && payments.subscriptionStatus
        && payments.subscriptionStatus.status &&
        payments.subscriptionStatus.subscriptionType
        && payments.subscriptionStatus.orderId
        && ((payments.subscriptionStatus.status == "EXPIRED" && payments.subscriptionStatus.subscriptionType === "PAID") ||
          (payments.subscriptionStatus.status == "PROCESSING" && payments.subscriptionStatus.subscriptionType === "PAID")) &&
        <div className={classes.pad} onClick={(e) => { goToTryAgainPayment(payments.subscriptionStatus.orderId) }} >
          {/* <div className={classes.subscriptionStatusDiv}>
            <span><span className={classes.status}>Your Last Payment Failed, please retry payment again</span></span>
            <span><span className={classes.checkPrice}>Click to process<ChevronRightIcon className={classes.go} /></span></span>
        </div> */}
          <Box display="flex" justifyContent="space-between" alignItems="center" flexDirection="row" className={classes.subscriptionStatusBox}>
            <Box>
            </Box>
            <Box>
              <span className={classes.status}>Your last payment failed, please retry payment again</span>
            </Box>
            <Box>
              <span className={classes.checkPrice}>Click to process<ChevronRightIcon className={classes.go} /></span>
            </Box>
          </Box>
        </div>}

      {fuelCardActivation && <DriverDetailsDialog open={fuelCardActivation} onClose={handleDriverDetailsClose} truckInfo={vehicle && vehicle.singleTruck ? vehicle.singleTruck : {}} fromSingleTruck={true} />}

      {children}
    </main>
  );
};

Workspace.prototypes = {
  children: PropTypes.node.isRequired,
  opened: PropTypes.bool
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetSubscriptionPaymentLinkAction: (id, onSuccess, onFailure) => {
    dispatch(getPaymentLink(id, onSuccess, onFailure))
  }
});
const WorkspaceWithRouter = withRouter(Workspace);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkspaceWithRouter);
